import {Injectable} from '@angular/core';
import {Store} from "@ngrx/store";
import {AppState} from "../../index";
import { Actions } from '@ngrx/effects';


@Injectable()
export class AuthUserEffects {


  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
  ) { }
  
}
